export default {
  PATIENT_QUALIFICATION: 'patientQualification',
  IN_CLAIM_ELIGIBILITY: 'inClaimEligibility',
  REVIEW_IN_CLAIM_ELIGIBILITY: 'reviewInClaimEligibility',
  ORDER_LINE_ITEMS: 'orderLineItems',
  ORDER_VERIFICATION: 'orderVerification',
  PRODUCT_FULFILLMENT: 'productFulfillment',
  BULK_LABELS: 'bulkLabels',
  READY_TO_SHIP: 'readyToShip',
  REVIEW_ADJUDICATION: 'reviewAdjudication',
  INCOMPLETE_PROFILES: 'profileIncomplete',
  PRESCRIPTION_REVIEW: 'prescriptionReview',
  E_VISIT_REQUESTS: 'eVisitRequests',
  RX_INTAKE_REQUESTS: 'rxIntakeRequests',
  PROCESSED_EXTERNAL_ORDERS: 'processedExternalOrders',
  RECONCILE_SHIPMENT: 'reconcileShipment',
  COMPOUNDING_QUEUE: 'compoundingQueue',
  FILL_LATER: 'fillLater',
  // POM-6223. The value matches the backend field name `nonRoutableRequests`, not the operator
  // label "Non-Routable Orders" — no order exists, and preventing one is the point of the feature.
  NON_ROUTABLE_REQUESTS: 'nonRoutableRequests',
};

/**
 * POM-6099 — the two views inside the Central Fill Rx tab.
 *
 * Relay is a MODE of that tab, not a tab of its own: it is POM sys-admin only, so a tab would be
 * absent for almost everyone, and the two views answer the same operator question about two
 * different fulfilment routes. CENTRAL_FILL is the default because relay is the minority view.
 */
export const CENTRAL_FILL_MODE = {
  CENTRAL_FILL: 'CENTRAL_FILL',
  RELAY: 'RELAY',
};

// A direction means one thing, for every drug that uses it. The server refuses to change what it
// means unless the reviewer has been told and said yes.
export const DIRECTION_ALREADY_MAPPED = 'DIRECTION_ALREADY_MAPPED';
